<div class="verification-drivers">
    <div class="container">
        <div class="info-content">
            <div class="info">
                <div class="portalLogo"></div>
                <h3 class="mt-5">Drivers Information</h3>
                <p>Note: Motor Vehicle Reports (MVR) will be run on active drivers before the policy renewal on July 1.</p>
                <self-ins-policies-and-request-page></self-ins-policies-and-request-page>
            </div>
            <div class="contacts">
                <p class="m-0">Contact us:</p>
                <div>
                    <a href="mailto:AFPsupport@mcgriff.com?subject={{user?.verificationInfo?.insuredName ? user?.verificationInfo?.insuredName : ''}}">
                        AFPsupport@mcgriff.com
                    </a>
                    <span></span>
                    <a href="tel:+18448186243">844-818-6243</a>
                </div>
            </div>
            <div class="footer mt-2">
                <a
                    href="https://www.marshmma.com/us/privacy-notice.html"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Privacy Notice
                </a>
            </div>
        </div>
        <div class="main-content">
            <div class="table-cont">
                <div class="header-nav">
                <div class="searchBar">
                    <input
                        id="search"
                        class="form-input"
                        placeholder="Search"
                        (keyup)="applySearch()"
                        [(ngModel)]="gridSearchValue"
                    />
                    <label
                        for="search"
                        class="form_label"
                    >Search
                    </label>
                </div>
                    <div class="filter">
                        <ng-select
                            bindLabel="label"
                            bindValue="value"
                            [searchable]="false"
                            [clearable]="false"
                            [items]="dsGridFilter"
                            [(ngModel)]="gridFilterValue"
                            (ngModelChange)="filterGrid($event)">
                        </ng-select>
                    </div>
                </div>
                <table mat-table matSort [dataSource]="drivers">
                    <ng-container matColumnDef="firstName">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>First Name</th>
                        <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="lastName">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Last Name</th>
                        <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="dateOfBirth">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Date of Birth</th>
                        <td mat-cell *matCellDef="let element"> {{element.dateOfBirth | date: 'shortDate'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="hiredOn">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Hire Date</th>
                        <td mat-cell *matCellDef="let element"> {{element.hiredOn | date: 'shortDate'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="licensedState">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>License State</th>
                        <td mat-cell *matCellDef="let element"> {{element.licensedState}} </td>
                    </ng-container>
                    <ng-container matColumnDef="licenseNumber">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>License Number</th>
                        <td mat-cell *matCellDef="let element"> {{element.licenseNumber}} </td>
                    </ng-container>
                    <ng-container matColumnDef="yearsDrivingExperience">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Years Driving Experience</th>
                        <td mat-cell *matCellDef="let element"> {{element.yearsDrivingExperience}} </td>
                    </ng-container>
                    <ng-container matColumnDef="termDate">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Term Date</th>
                        <td mat-cell *matCellDef="let element"> {{element.termDate | date: 'shortDate'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>Action</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="d-flex align-items-center justify-content-center">
                                <a (click)="onEditDriver(element)"
                                    title="Edit Driver">
                                    <img src="../../../assets/edit-icon.svg" width="15" alt="edit-icon">
                                </a>
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row class="table-row" *matRowDef="let row; columns: displayedColumns;"></tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell noData text-center" colspan="10">No data matching the filter <b>"{{gridFilterValue}}"</b></td>
                    </tr>
                </table>
                <div class="text-center mt-2" *ngIf="!user || user.status !== 'active'">
                    <input type="checkbox" id="confirm" name="confirmData" [(ngModel)]="confirmData">
                    <label class="ms-2" for="confirm">I confirm the drivers data above is correct</label>
                </div>
                <div *ngIf="submitted && !confirmData" class="alert alert-danger w-50 mx-auto">
                    <span>Please confirm</span>
                </div>
                <div class="table-actions mt-2">
                    <button class="primary-button" (click)="addDriver()">
                        Add Driver
                    </button>
                    <p class="m-0">
                        <a href="mailto:AFPsupport@mcgriff.com?subject={{user?.verificationInfo?.insuredName ? user?.verificationInfo?.insuredName : ''}}">
                            Report
                        </a>
                        incorrect information
                    </p>
                </div>
            </div>
            <div class="actions pt-3">
                <button [routerLink]="user?.status === 'active' ? ['/coverage'] : ['/verification-tractors']"
                        [queryParams]="{ qnum: qnum, qsuffix: qsuffix }"
                        class="primary-button">
                    Go back
                </button>
                <div *ngIf="!user || user.status !== 'active'">
                    <button (click)="onSubmit()" class="primary-button ms-3">
                        Continue
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<self-ins-drivers-modal
    #modal
    (onHidden)="$event && this.onSaveDriver($event)">
</self-ins-drivers-modal>
